"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertToMetaState = convertToMetaState;
exports.convertToFormMetaState = convertToFormMetaState;
function convertToMetaState(meta) {
    const metaState = {};
    for (const [key, value] of Object.entries(meta)) {
        if (typeof value === "string") {
            metaState[key] = value;
        }
        else {
            metaState[key] = toMapOrList(value);
        }
    }
    return metaState;
}
function convertToFormMetaState(formModel) {
    const formMetaState = {
        phase: "meta",
        meta: convertToMetaState(formModel.meta),
        terms: {},
        iterables: {},
    };
    for (const [termName, term] of Object.entries(formModel.terms)) {
        formMetaState.terms[termName] = {
            name: termName,
            meta: term.meta && convertToMetaState(term.meta),
        };
    }
    for (const [iterableName, iterable] of Object.entries(formModel.iterables)) {
        for (const [termName, term] of Object.entries(iterable.terms)) {
            if (!formMetaState.iterables[iterableName]) {
                formMetaState.iterables[iterableName] = {
                    name: iterableName,
                    terms: {},
                };
            }
            formMetaState.iterables[iterableName].terms[termName] = {
                name: termName,
                meta: term.meta && convertToMetaState(term.meta),
            };
        }
    }
    return formMetaState;
}
function toMapOrList(metatable) {
    if (metatable.every(m => m.type === "metalist-item")) {
        return metatable.map(m => typeof m.value === "string" ? m.value : toMap(m.value));
    }
    return toMap(metatable);
}
function toMap(metatable) {
    const metaMap = new Map();
    for (const [index, m] of metatable.entries()) {
        metaMap.set(m.type === "metatable-item" ? m.name : index, typeof m.value === "string" ? m.value : toMapOrList(m.value));
    }
    return metaMap;
}
//# sourceMappingURL=meta-state.js.map